var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiple-score"},[_c('el-button',{staticClass:"back",attrs:{"size":"small"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")]),_c('div',{ref:"chart",staticClass:"chart-container",staticStyle:{"height":"600px","width":"96%","margin":"20px auto"},attrs:{"id":"mychart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }